"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CaratLoader = void 0;
var Carat_1 = require("./Carat");
var colors_1 = require("../../constants/colors");
var Loader_1 = require("./Loader");
var React = __importStar(require("react"));
exports.CaratLoader = function (_a) {
    var showLoader = _a.showLoader, caratColor = _a.caratColor, margin = _a.margin, name = _a.name, className = _a.className, size = _a.size;
    return (React.createElement(React.Fragment, null,
        React.createElement(Carat_1.Carat, { active: showLoader, className: className, color: caratColor ? caratColor : colors_1.colors.BLUE_300, margin: margin, name: name, size: size }),
        showLoader ? React.createElement(Loader_1.Loader, { isFetching: showLoader }) : null));
};
//# sourceMappingURL=CaratLoader.js.map